import { useAuthenticatedUser } from "../components/indentity-provider.component"

export function useProfileId(): string {
  const user = useAuthenticatedUser()
  return user.udbId
}
